<div class="bookmark-content">
	<div class="app-modal-title">Reference Document Manager</div>
	<div class="bookmark-list">
		<div *ngFor="let col of columns; let idx = index;" class="bookmark-column">
			<div class="bookmark-header">
				{{col.name}}
			</div>
			<div *ngFor="let bm of bookmarkList; let idx2 = index" class="bookmark-cell" title="{{bm[col.prop]}}">
				<ng-container *ngIf="col.prop!=='name'&&col.prop!=='delete'">{{bm[col.prop]}}</ng-container>
				<ng-container *ngIf="col.prop==='name'">
					<div>
						<a [href]="bm.href" target="_blank" title="Description: {{bm.desc}}">
							{{bm[col.prop]}}
						</a>
					</div>
				</ng-container>
				<ng-container *ngIf="col.prop==='delete'">
					<div>
						<i *ngIf="userName===bm.userName" class="glyphicons glyphicons-bin" title="Delete bookmark" [ngClass]="{'disabled-icon': bm.id===deletingId}" (click)="deleteBookmark(bm)"></i>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="bookmark-add">
		<div class="same-line prop-line">
			<div class="bookmark-prop">
				<label>Name</label>
				<input required name="bookmarkName" [(ngModel)]="bookmarkName">
			</div>
			<div class="bookmark-prop">
				<label>Visibility</label>
				<select required name="bookmarkVisibility" [(ngModel)]="bookmarkVisib">
					<option *ngFor="let op of bookmarkVisibilities" [ngValue]="op.value">{{op.label}}</option>
				</select>
			</div>
		</div>
		<div>
			<div class="bookmark-prop">
				<label>Description</label>
				<input required name="bookmarkDesc" [(ngModel)]="bookmarkDesc">
			</div>
		</div>
		<div>
			<div class="bookmark-prop">
				<label>Href</label>
				<input required name="bookmarkHref" [(ngModel)]="bookmarkHref">
			</div>
		</div>
		<div class="button-group">
			<button class="button-general" (click)="cancel()">Cancel</button>
			<button class="button-general" [disabled]="!bookmarkName||!bookmarkVisib||!bookmarkDesc||isAdding" (click)="addBookmark()">Add</button>
		</div>
	</div>
</div>